import { enhancementSubmitStatusDisplayNames } from "../constants"
import { isEnhancementSubmitStatus } from "./isEnhancementSubmitStatus"

export const getRequestStatusDisplayName = (requestStatus: string | undefined): string | undefined => 
  requestStatus && isEnhancementSubmitStatus(requestStatus)
    ? enhancementSubmitStatusDisplayNames[requestStatus]
    : requestStatus
